module.exports = __webpack_public_path__ + "img/left.e76b28b0.png";